const Description = require("./Description");
const List = require("./List");
const Row = require("./Row");
const Term = require("./Term");

module.exports = {
  Description,
  List,
  Row,
  Term,
};
